import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ForgotService {

  api: string = environment.backend;

  constructor(private http: HttpClient) { }

  login(mail) {
    return this.http.get(this.api + 'login/' + mail );
  }
}
